//validationSchema
import * as yup from 'yup';
import { InitialVehicleType } from '../../store/ducks/vehicleType/types';

export type VehicleFormType = Omit<
  InitialVehicleType,
  | 'costPerAssistant'
  | 'driverCost'
  | 'costPerKilometer'
  | 'costPerTon'
  | 'costPerOrder'
  | 'payloadCapacity'
  | 'packLoadWeight'
  | 'costPerCubicMeter'
  | 'createdAt'
  | 'updatedAt'
  | 'vehicleTypeId'
> & {
  costPerAssistant: number;
  driverCost: number;
  costPerKilometer: number;
  costPerTon: number;
  costPerOrder: number;
  payloadCapacity: number;
  packLoadWeight: number;
  costPerCubicMeter?: string;
};

const validationSchema = yup.object().shape<VehicleFormType>({
  vehicleType: yup
    .string()
    .required('O nome não pode estar vazio')
    .max(150, 'O nome pode ter até 150 caracteres'),
  costPerAssistant: yup
    .number()
    .typeError('Diária do ajudante deve ser um número')
    .min(1, 'Diára do ajudante não pode ser menor que 1')
    .max(10000, 'Diára do ajudante não pode ser maior que 10000')
    .required('Diária do ajudante não pode estar vazia'),
  driverCost: yup
    .number()
    .typeError('Diária do motorista deve ser um número')
    .min(1, 'Diária do motorista não pode ser menor que 1')
    .max(10000, 'Diária do motorista não pode ser maior que 10000')
    .required('Diária do motorista não pode estar vazia'),
  costPerKilometer: yup
    .number()
    .typeError('Preço por quilômetro deve ser um número')
    .min(1, 'Preço por quilômetro não pode ser menor que 1')
    .max(10000, 'Preço por quilômetro não pode ser maior que 10000')
    .required('Preço por quilômetro rodado não pode estar vazio'),
  costPerTon: yup
    .number()
    .typeError('Preço por tonelada deve ser um número')
    .min(1, 'Preço por tonelada não pode ser menor que 1')
    .max(10000, 'Preço por tonelada não pode ser maior que 10000')
    .required('Preço por tonelada carregada não pode estar vazio'),
  costPerCubicMeter: yup
    .string()
    .typeError('Preço por metro cúbico deve ser um número'),
  costPerOrder: yup
    .number()
    .typeError('Preço por pedido deve ser um número')
    .min(1, 'Preço por pedido não pode ser menor que 1')
    .max(10000, 'Preço por pedido não pode ser maior que 10000')
    .required('Preço por entrega realizada não pode estar vazio'),
  payloadCapacity: yup
    .number()
    .typeError('Capacidade de carga deve ser um número')
    .min(0.01, 'Capacidade de carga não pode ser menor que 0.01 toneladas')
    .max(999, 'Capacidade de carga não pode ser maior que 1000 toneladas')
    .required('Capacidade de carga não pode estar vazia'),
  packLoadWeight: yup
    .number()
    .typeError('Peso da embalagem deve ser um número')
    .min(0.01, 'Peso da embalagem não pode ser menor que 0.01')
    .max(999, 'Peso da embalagem não pode ser maior que 1000 toneladas')
    .required('Peso da embalagem não pode estar vazia'),
});

export default validationSchema;
